module.exports = __webpack_public_path__ + "img/experts-video-image2.bfe99662.svg";